<template>
  <main class="absolute-container">
    <Header>
      <div class="error-container col-md-6 m-auto">
        <div class="error-main">
          <div class="error-number">{{ $t("error404.number") }}</div>
        </div>
      </div>
    </Header>
    <div class="container d-flex flex-column">
      <div class="error-detail col-md-6 m-auto">
        <div class="error-main">
          <div class="error-title">{{ $t("error404.title") }}</div>
          <div class="error-description">{{ $t("error404.description") }}</div>
          <br/>
          <router-link :to="{name: 'home'}">
            <span class="volver-caret">
              <span class="caret-left"/>
            </span>
            <span class="volver-error">{{ $t("button.backHome") }}</span>
          </router-link>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Header from '@/components/Header.vue';

export default {
  components: {
    Header,
  },
};
</script>

<style lang="scss" scoped>
  @import "../assets/scss/variables";

  .error-main {
    text-align: center;
  }

  .error-title {
    font-size: 32px;
    font-weight: 400;
    padding-bottom: 1rem;

    @media (max-width: 767px) {
      & {
        font-size: 30px;
      }
    }
  }

  .error-description {
    font-size: 18px;
    font-weight: 400;

    @media (max-width: 767px) {
      & {
        font-size: 1rem;
      }
    }
  }

  .error-number {
    font-size: 80px;
    font-weight: 300;
    line-height: 130px;

    @media (max-width: 767px) {
      & {
        font-size: 60px;
      }
    }
  }

  .error-detail {
    color: $dark-color;

    .error-main {
      margin-top: 10%;
    }
  }

  .volver-caret {
    background-color: $prosegur-color;
    border-radius: 3px;
    width: 16px;
    height: 16px;
    margin-right: 10px;
    color: $dark-color;
    font-size: 16px;
    display: inline-flex;
    vertical-align: top;
  }

  .caret-left {
    border-bottom: 5px solid transparent;
    border-top: 5px solid transparent;
    border-right: 5px solid;
    display: inline-block;
    height: 0;
    width: 0;
    margin: auto auto auto 5px;
  }

  .volver-error {
    display: inline-block;
    color: $dark-color;
    font-size: 1em;
    line-height: 1em;
    vertical-align: top;
  }

  a,
  a:active,
  a:focus,
  a:hover {
    outline: 0;
    text-decoration: none;
  }
</style>
